import styled from 'styled-components';

export const PreviousViewMain = styled.section`

  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  backdrop-filter: blur(5px);

  opacity: ${props => props.previousViewActive ? '1' : '0'};
  visibility: ${props => props.previousViewActive ? 'visible' : 'hidden'};
  pointer-events: ${props => props.previousViewActive ? 'all' : 'none'};
  transition: all .2s ease;

  z-index: ${props => props.previousViewActive ? '50' : '-1'};

`;

export const PreviousViewContainer = styled.div`

  width: 80%;
  max-width: 60rem;
  overflow: hidden;

  background-color: rgb(255, 255, 255);
  border-radius: 8px;
  box-shadow: 0 0px 6px rgba(0, 0, 0, 0.2);
  margin-left: 4rem;

  article {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

`;

export const PreviousViewHeader = styled.header`

  position: sticky;
  top: 0;

  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 1.5rem;

  overflow: hidden;

  background-color: #fff;
  padding: .5rem 1.5rem .5rem .5rem;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  div.info_container {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;

    // background-color: rgba(224, 58, 168, 0.1);
    padding: 0.5rem 1rem;
    border-radius: 8px;

    > img {
      width: 20px;
      height: 20px;
    }

    > div {

      display: flex;
      flex-direction: column;
      // align-items: center;
      gap: 4px;

      h2 {
        font-size: 1rem;
        margin: 0;
        color: rgb(224, 58, 168);
      }

      h4 {
        font-size: 12px;
        margin: 0;
        font-weight: normal;
        color: #555;
      }

    }

  }

  svg {
    color: #E03AA8;
    cursor: pointer;
  }

`;

export const PreviousViewContent = styled.div`

  max-height: 80vh;
  overflow-y: auto;
  margin-top: 1rem;
  padding: 0 1.5rem 1.5rem 1.5rem;

`;

export const ObligatoryCellEmpty = styled.div`

  width: 100%;
  height: 100%;
  background-color: red;

`;

export const PreviousViewLoading = styled.div`

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  padding: 3rem 0;

  > img {
    width: 3rem;
    height: 3rem;
  }

`;

export const PreviousViewButtons = styled.div`

  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1.25rem;

  > button {

    color: #fff;
    background-color: #d637a4;
    border: 1px solid #d637a4;
    padding: .5rem 1rem;
    border-radius: 5px;
    cursor: pointer;

    :hover {
      opacity: 0.8;
    }

    &.cancel {
      color: #d637a4;
      background-color: #fff;
    }

  }

`;